import { PAGINATE_SIMULATIONS } from './constants'

export const paginateSimulations = (page) => ({
  type: PAGINATE_SIMULATIONS,
  payload: { page },
})
